import VXETable from "vxe-table";

// 全局参数的配置尽量就按照官网中的顺序配置，否则可能会出现配置没有生效的情况（可能是自定义配置和全局配置合并导致的）
VXETable.setup({
  table: {
    autoResize: true,
    border: false,
    // showOverflow: true,
    // showHeaderOverflow: true,
    // showFooterOverflow: true,
    // emptyText: '暂无数据',
    emptyRender: {
      name: "NoData"
    },
    align: 'center',
    rowConfig: {
      useKey: true,
      isHover: true,
      isCurrent: true,
    },
    columnConfig: {
      useKey: true,
      isHover: true,
      isCurrent: true
    },
    // scrollX: {
    //   enable: false,
    // },
    // scrollY: {
    //   enable: false,
    // }
  },
  grid: {
    proxyConfig: {
      seq: true, // 启用动态序号代理，每一页的序号会根据当前页数变化
      sort: true, // 启用排序代理，当点击排序时会自动触发 query 行为
      filter: true, // 启用筛选代理，当点击筛选时会自动触发 query 行为
      form: true, // 启用表单代理，当点击表单提交按钮时会自动触发 reload 行为
    },
  },
  pager: {
    background: true,
    pageSizes: [15, 30, 50, 100, 200],
    layouts: ['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']
  },
  form: {
    titleColon: true,
  },
  input: {
    clearable: true,
    controls: false,
  },
  checkboxConfig: {
    reserve: true,
    highlight: true,
    range: true
  },
  select: {
    transfer: true
  },
  modal: {
    resize: true,
  }
})


/* 以上为全局参数配置 */




// 日期范围，日期时间范围渲染器
VXETable.renderer.add('FormItemDateRange', {
  renderItemContent (h, renderOpts, params) {
    const { data, property, $form } = params
    const props = renderOpts.props || {}
    const events = renderOpts.events || {}
    let valueFormat = 'yyyy-MM-dd'
    if (props?.type?.includes?.('datetime')) {
      valueFormat = 'yyyy-MM-dd HH:mm:ss'
    } else if (props?.type?.includes?.('month')) {
      valueFormat = 'yyyy-MM'
    }
    return [
      <el-date-picker
        v-model={data[property]}
        type="daterange"
        size="medium"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format={valueFormat}
        onChange={
          () => {
            events.change && events.change(params)
          }
        }
        { ...{ props } }>
      </el-date-picker>
    ]
  }
})

// 数字输入范围渲染器
VXETable.renderer.add('FormItemNumberRange', {
  renderItemContent (h, renderOpts, params) {
    const { data, property } = params
    const props = renderOpts.props || {}
    return [
      <input-range v-model={data[property]} {...{ props }}
      ></input-range>
    ]
  }
})

// #region
/* 
  支持搜索，多选的下拉
  使用：
  {
    title: '多选可搜索',
    field: 'real_filed_val_mul',
    itemRender: {
      name: 'FormItemSelect',
      props: {
        filterable: true,
        multiple: true,
        collapseTags: true,
        options: [{
          value: '选项1',
          label: '黄金糕'
        }],
      }
    }
  }
*/
// #endregion
VXETable.renderer.add('FormItemSelect', {
  renderItemContent (h, renderOpts, params) {
    const { data, property } = params
    const props = renderOpts.props || {}
    let { options = [], multiple } = props
    let lastVal = []
    return [
      <el-select size="medium"
        clearable
        v-model={data[property]} {...{ props }} placeholder="请选择"
        onChange={
          (val) => {
            // 选择全部的相关交互逻辑
            if (multiple && val.includes('')) {
              data[property] = options.filter(x => x.value !== '').map(x => x.value)
            }
          }
        }
      >
        {
          options.map((item, index) => {
            return <el-option
              key={index}
              label={item.label}
              value={item.value}>
            </el-option>
          })
        }
      </el-select>
    ]
  }
})


VXETable.renderer.add('NoData', {
  renderEmpty (h, renderOpts) {
    const imgSrc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAMAAACZHrEMAAAAaVBMVEUAAADU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NTU1NQPVxsJAAAAInRSTlMAMyy73mbN5wdIhh/vDfkUe6+n9aDZwXRgkW1ZP9Max1GXI1HkjAAABKFJREFUeNrs2OmSojAUBeDD1gTCLiquref9H3IcJOX86CZLky6qxu83yqmYe+MNfk62mzgXWAUR86HDKgwcSaxBw9EZazCFybAGxzWFSTg6YQ2GNYU5cZRgDW42Yc4Xbm+wFUoYyjjaGwWvHLpAEJM7aRWmgV62oX23LmM+pCFMnI3DBAVHEWxkHBUBDAQc5dAJUz41LmG4yaAXGoaRKsulhI1Sfa66GYe5Y951y6ftFXaCgpMBOtIoTH3hUyphK0g5ORqG6TGn/FRZQtgLY9JsM9TU16uI+KoJB3LLyQGzSo5azGhfFeGm/uCkx6xK+1D/qgdX5Y6TVmBGx79m3nPn5AR3IuIkKueWcDe/s47kEge76EiTDh5mcuZLCsvGq1/hG1yFmqq0kPNpD1dl9WyK6/jz3yw45CVqzzgbot0RCwn69riSUfrt7e3tPxIMyZIyAWfhhQtLMzg6F1zeACe3ij7s4SChJzms7enNHZZyetQJ2OippB+L2VKJShgTLZVdieX0VD5r+1GSrcCSDlQuV9shmz0W1lCJpd31Aw9Y3JG0uKkJUyoNPDhVNL6rCQoqCbzINpxsMu2T1ncp7kdeddKuoUrtTZBSSYx2VwCPwli/LxvNTrfnXrEHKlsJn/S9THRUPmr4pO/yZeR0irkT7bcvrD9ngvoh+m9+iuuFSg8PtJv0+mWp5fhFOZU4/KIJ7eGVvrGdCyoDftlApTjjIate8SIjCQwEXWQi5b8HULihtYNBloq2ComODiR0dk4jTEoHN+gUtJfC08BMF/AzL9c/CpP+ad/clhwFgQDaeAmgqNHEWzQ66f//yH3AbLtrHNmtQqwaz6uGOtUgdjcxMCM126b7fxqV/yXjgRm5rnoMK3UJRnj/KXM1e5ymHCCzK8OMqpgBKYAWZaatgAuTN2BkW6Y1+CNApmhQezI0Tyrb7jZUYFsG/M3z3A410r4M20rDmKLA2JaBAjXXjc4B20Mm46hpBSyRiiK3gwxInBgXvxLR72tiHxlqy6bt8IdKE+AEH8C2zDKtT/Mum0z6iC+KdbsyZEMEVVH4zxQJzmBHGWhSXOcZw64ywEpcoxWwswwk0Q0/cekBdpMh4nap8+wAdpUhstBPkeCvHmB/GULI+pX7lV9EDY3hQGbBKXPKrHAgGZGAEYmwLSMijqj8RmzcFlY3RN4mVmVeqCl7+AYZoKawKkMt2ofJ2d/Fqkz2yDnZfO9S3htb00R4LWX/692QKLb/NLGwbr5GnXLDR/RFX3ZhY7m8zXHGsNKAIHKbMgznMINbLMqICxKB+HgLR+IirK4Zj0nZhde7P7YrKzR+jVURPToppfez3k0Ap8wap8wah5b5KkpV3uURZLwnaqrYuQyjEpfHzmSowccfA8TXG+JTuJWJdECmEIVuZThiR52+0alMhpiKWSYjnMjQMAG8uSEmTqfJx3q2fu7gfNM71A58yrw5Zdb4ITKKqi03UOGXQklnfM6otUPwrp6Vw3mK+bu1FKJGRT1zQ81R00HC8SCoBOCBB6HWnYVDUOmkKMADUGagbQ4QG/peRFwVOkXVMCMJ8yBFJ6RBHiba4hf3x0LsyuvSSgAAAABJRU5ErkJggg=="
    return [
      <div class="cw-table-nodata">
        <img src={imgSrc}/>
        <p>啊哦 没有数据了哦~</p>
      </div>
    ]
  }
})